import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Inject,
  Renderer2,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { UsMapService } from "../us-map.service";
import { TuiDialogContext } from "@taiga-ui/core";
import { POLYMORPHEUS_CONTEXT } from "@tinkoff/ng-polymorpheus";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";
@Component({
  selector: "app-another-map",
  templateUrl: "./another-map.component.html",
  styleUrls: ["./another-map.component.scss"],
})
export class AnotherMapComponent implements OnInit {
  showsTooltip = false;
  tooltipText: any;
  topPosition = 20;
  leftPosition = 415;
  //add =false;
  Repocitycoordinates: any;
  RepocitystateList = [];
  isClicked = false;
  fillStyle: string;
  isSelected = false;
  @Input() fillColor: string = "#FFFFFF";
  @Input() fillStateColor: string = "#aeaeae";
  @Input() strokeColor: string = "#000000";
  @Output("onMapClick") click = new EventEmitter();
  @ViewChild("repocitytooltip") repocitytooltip: ElementRef;
  constructor(
    private usMapService: UsMapService,
    private renderer: Renderer2,
    public globalvar: GlobalVarService,
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<any, any>
  ) {}

  ngOnInit(): void {
    const tooltip = document.getElementById("repocitytooltip");
    tooltip.style.display = "none";
    this.renderer.setStyle(tooltip, "display", "none");
    this.Repocitycoordinates = this.usMapService.getUsMapReciprocityCoordinates();
    // if (this.globalvar.ReciprocitySelectedStateList.length > 0) {
      this.RepocitystateList = this.globalvar.ReciprocitySelectedStateList;
    // }
  }

  fillcolor(colour: any) {
    const matchcolor = this.RepocitystateList.filter(
      (element) => element.toLowerCase() == colour.toLowerCase()
    );
    const findColor = matchcolor.length > 0 ? "#f26722" : "#aeaeae";
    return findColor;
  }

  onUsMapClick(state) {
    let arr = this.RepocitystateList.filter(
      (el) => el.toLowerCase() == state.toLowerCase()
    );
    if (arr.length == 0) {
      this.RepocitystateList.push(state);
      const unqueiArr = [
        ...new Set(this.RepocitystateList.map((item) => item.toLowerCase())),
      ];
      // console.log("Unique",uniqueLowercaseArray);
      // this.RepocitystateList=unqueiArr;
      this.globalvar.ReciprocitySelectedStateList = unqueiArr;
      this.isClicked = true;
      document.getElementById(state).style["fill"] = "#f26722"; //orange
      this.globalvar.subscribeReciprocityMapForChecked(state);
      console.log(this.RepocitystateList);
    } else {
      let rsind = this.RepocitystateList.indexOf(state.toLowerCase());
      if (rsind != -1) {
        this.RepocitystateList.splice(rsind, 1);
      }
      this.globalvar.ReciprocitySelectedStateList = this.RepocitystateList;
      document.getElementById(state).style["fill"] = "#aeaeae";
      this.globalvar.subscribeReciprocityMapForUnChecked(state.toLowerCase());
    }
  }

  onmouseLeave(id) {
    if (this.RepocitystateList.length > 0) {
      const a = this.RepocitystateList.includes(id);
      if (a == true) {
        document.getElementById(id).style["fill"] = "#f26722"; // selected blue
      } else {
        this.isClicked = false;
        document.getElementById(id).style["fill"] = "#aeaeae"; // unselect grey
      }
    } else {
      document.getElementById(id).style["fill"] = "";
    }
    // if (id != null) {
    //   if (this.RepocitystateList.length > 0) {
    //     const a = this.RepocitystateList.includes(id.toLowerCase());
    //     if (a == true) {
    //       this.isClicked = true;
    //     } else {
    //       if (this.isClicked == true) {
    //         document.getElementById(id).style["fill"] = "#aeaeae";
    //       } else {
    //         this.isClicked = false;
    //         document.getElementById(id).style["fill"] = "#aeaeae";
    //       }
    //     }
    //   } else {
    //     if (!this.isClicked) {
    //       document.getElementById(id).style["fill"] = "#aeaeae";
    //     } else {
    //       this.isClicked = false;
    //     }
    //   }
    // }
  }
  showtool: boolean = false;
  onHover(tooltipText: any, id, event: MouseEvent) {
    if (id != null) {
      document.getElementById(id).style["fill"] = "#103677"; // blue
      const mydiv = document.getElementById("allcontent");
      const tooltip = document.getElementById("repocitytooltip");
      // Calculate the width and height of myDIV
      let width = mydiv.offsetWidth;
      let height = mydiv.offsetHeight;
      // Calculate the width and height of the tooltip
      let tooltipWidth = tooltip.offsetWidth;
      let tooltipHeight = tooltip.offsetHeight;

      // Calculate the x and y coordinates relative to myDIV
      let x =
        event.clientX - mydiv.getBoundingClientRect().left - tooltipWidth / 2;
      let y =
        event.clientY - mydiv.getBoundingClientRect().top - tooltipHeight / 2;

      // Set the position of the tooltip
      tooltip.style.left = x + "px";
      tooltip.style.top = y + "px";

      // Display the tooltip with the provided text
      tooltip.innerHTML = tooltipText;
      // tooltip.style.display = "block";
      this.renderer.setStyle(tooltip, "left", x);
      this.renderer.setStyle(tooltip, "top", y);
      this.renderer.setStyle(tooltip, "display", "inline");

      this.renderer.setProperty(
        this.repocitytooltip.nativeElement,
        "innerHTML",
        tooltipText
      );
    }
  }
  onMouseout() {
    const tooltip = document.getElementById("repocitytooltip");
    tooltip.style.display = "none";
    this.renderer.setStyle(tooltip, "display", "none");
    this.tooltipText = "";
    this.topPosition = null;
    this.leftPosition = null;
  }

  close() {
    this.context.completeWith("");
    const dialog = document.querySelector("tui-dialog");
    dialog.classList.remove("stateMap");
  }
}
